import { render } from "./index.vue?vue&type=template&id=37800124&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=37800124&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=1&id=37800124&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37800124"]])

export default __exports__